import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ButtonDirective} from 'primeng/button';
import {TranslatePipe} from '@ngx-translate/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-clear-button',
  standalone: true,
  templateUrl: './clear-button.html',
  imports: [
    ButtonDirective,
    TranslatePipe,
    NgClass
  ],
  styleUrl: './clear-button.scss'
})
export class ClearButton {
  @Output() clear = new EventEmitter<void>();
  @Input() label: string = 'Clear';
  @Input() icon: string = 'pi pi-times';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() styleClass: string = '';

  onClear(): void {
    this.clear.emit();
  }
}
